import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-modal-video',
  templateUrl: './modal-video.component.html',
  styleUrls: ['./modal-video.component.css']
})
export class ModalVideoComponent implements OnInit {
  widthIframe : number;
  heightIframe : number;
  url:string ;
  urlSafe: SafeResourceUrl;
  size: string;
  constructor(public dialogRef: MatDialogRef<ModalVideoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.url = this.data.url;
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.size = this.data.size;
    if(this.size === "xl"){
      this.widthIframe = 900;
      this.heightIframe = 600;
    }else{
      this.widthIframe = 600;
      this.heightIframe = 350;
    }

  }
  onNoClick(){
    this.dialogRef.close();
  }

}
